import { gql } from "@apollo/client";

export const DeleteGridView = gql`
    mutation DeleteGridView($id: ID!) {
        deleteGridView(id: $id) {
            success
            message
        }
    }
`;
